export enum DoBoxReplyDraftStatus {
  GENERATING = 'GENERATING',
  READY = 'READY',
  SENDING = 'SENDING',
  SENT = 'SENT',
  ERROR = 'ERROR',
}
